import { render, staticRenderFns } from "./LocationVideos.vue?vue&type=template&id=0cb1978c&scoped=true"
import script from "./LocationVideos.vue?vue&type=script&lang=js"
export * from "./LocationVideos.vue?vue&type=script&lang=js"
import style0 from "./LocationVideos.vue?vue&type=style&index=0&id=0cb1978c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb1978c",
  null
  
)

export default component.exports